import React, { useRef } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import { CoreButton, CoreTextField } from 'src/components/core'
import { useSelector } from 'react-redux'
import {
  WIDGET_JS_TEMPLATE,
  WIDGET_HTML_TEMPLATES,
} from '../constants/code-templates'
import styles from './styles'

const CodeView = ({
  classes,
  label,
  code,
  textFieldValue,
  onTextFieldChange,
  buttonLabel,
  buttonAttributes,
  widgetType = 'modal',
  config = {},
}) => {
  const codeRef = useRef()
  const collection = useSelector(state => state.collection.collection)
  const user = useSelector(state => state.authentication.me)
  const name = user?.name != null ? user?.name : ''
  const surname = user?.surname != null ? user?.surname : ''
  const nameSurname = name + ' ' + surname
  const handleCopy = () => {
    label.toLowerCase() === 'javascript'
      ? navigator.clipboard.writeText(generateButtonJs())
      : navigator.clipboard.writeText(generateButtonHTML())
  }

  const generateButtonHTML = () => {
    if (widgetType === 'embed') {
      return WIDGET_HTML_TEMPLATES.embed(config)
    }

    const templateConfig = {
      selector: buttonAttributes?.id || `#${widgetType}-widget`,
      widget: widgetType,
      collection: collection?.id,
      title: config.title || '',
      // The owning shop's key, not the viewer's: see WIDGET_JS_TEMPLATE.
      publicKey: collection?.publicKey ?? user?.publicKey ?? '',
      userName: user?.email || '',
      nameSurname: nameSurname || '',
      ...config,
    }

    return WIDGET_HTML_TEMPLATES[widgetType]?.(templateConfig) || ''
  }

  const generateButtonJs = () => {
    const templateConfig = {
      selector:
        widgetType === 'embed' ? 'embed-widget' : `${widgetType}-widget`,
      widget: widgetType,
      ...config,
    }

    return WIDGET_JS_TEMPLATE(templateConfig, collection, user)
  }

  return (
    <Box className={classes.root}>
      {textFieldValue !== undefined && (
        <CoreTextField
          className={classes.textField}
          value={textFieldValue}
          onChange={onTextFieldChange}
          fullWidth
          size="small"
        />
      )}
      <Typography fontSize={'14px'} fontWeight={500}>
        {label}
      </Typography>
      <Typography
        fontSize={14}
        fontWeight={400}
        className={classes.description}
      >
        {label.toLowerCase() === 'javascript'
          ? 'Place this JavaScript code before closing of your body tag'
          : 'Place this element where you wish the widget to appear'}
      </Typography>
      <div className={classes.codeBlock} ref={codeRef}>
        <Typography variant="body2" className={classes.codeText}>
          {label.toLowerCase() === 'javascript'
            ? generateButtonJs()
            : generateButtonHTML()}
        </Typography>
      </div>
      <CoreButton
        className={classes.button}
        color="secondary"
        variant="contained"
        onClick={handleCopy}
        fullWidth
      >
        {buttonLabel}
      </CoreButton>
    </Box>
  )
}

export default withStyles(styles)(CodeView)
